import MarkdownIt from "markdown-it";
import hljs from "highlight.js/lib/core";
import python from "highlight.js/lib/languages/python";
import pythonRepl from "highlight.js/lib/languages/python-repl";

hljs.registerLanguage("python", python);
hljs.registerLanguage("pycon", pythonRepl);

export function highlight(code, language = "python") {
  if (!hljs.getLanguage(language)) return escapeHtml(code);
  return hljs.highlight(code, { language, ignoreIllegals: true }).value;
}

function escapeHtml(text) {
  return text.replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch]);
}

// `html: false` escapes any raw HTML in the content, so rendering the output is safe.
const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: false,
  highlight: (code, language) =>
    `<pre class="code-block"><code class="hljs">${highlight(code, language || "python")}</code></pre>`,
});

const defaultLinkOpen =
  md.renderer.rules.link_open || ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet("target", "_blank");
  tokens[idx].attrSet("rel", "noopener noreferrer");
  return defaultLinkOpen(tokens, idx, options, env, self);
};

const defaultTableOpen = md.renderer.rules.table_open || ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));
md.renderer.rules.table_open = (tokens, idx, options, env, self) =>
  `<div class="table-scroll">${defaultTableOpen(tokens, idx, options, env, self)}`;
md.renderer.rules.table_close = () => "</table></div>";

export function renderMarkdown(source) {
  return md.render(source || "");
}

export function renderInlineMarkdown(source) {
  return md.renderInline(source || "");
}
